var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertTriangle48New(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEF0C7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FFFAEB",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0027 23.9992V27.9992M28.0027 31.9992H28.0127M26.2927 18.8592L17.8227 32.9992C17.6481 33.3017 17.5557 33.6445 17.5547 33.9937C17.5537 34.343 17.6442 34.6864 17.8171 34.9898C17.9901 35.2931 18.2394 35.546 18.5404 35.7231C18.8414 35.9002 19.1835 35.9954 19.5327 35.9992H36.4727C36.8219 35.9954 37.164 35.9002 37.465 35.7231C37.766 35.546 38.0153 35.2931 38.1883 34.9898C38.3612 34.6864 38.4517 34.343 38.4507 33.9937C38.4497 33.6445 38.3573 33.3017 38.1827 32.9992L29.7127 18.8592C29.5344 18.5653 29.2834 18.3223 28.9839 18.1537C28.6844 17.9851 28.3464 17.8965 28.0027 17.8965C27.659 17.8965 27.321 17.9851 27.0215 18.1537C26.722 18.3223 26.471 18.5653 26.2927 18.8592Z",
    stroke: "#DC6803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle48New);
export default __webpack_public_path__ + "static/media/alert-triangle-48-new.e7208e1bd864322672120ba5d213f40b.svg";
export { ForwardRef as ReactComponent };